import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import arrayEntry from '../fragments/arrayEntry.js';
import departmentMember from './departmentMember.js';
var schema = defineObject('department', {
    title: {
        title: 'Title',
        type: 'string'
    },
    primaryMembers: {
        title: 'Primary members',
        type: 'array',
        of: [
            {
                type: 'departmentMember'
            }
        ]
    },
    otherMembers: {
        title: 'Other members',
        type: 'array',
        of: [
            {
                type: 'departmentMember'
            }
        ]
    }
}, [
    departmentMember.schema.departmentMember
]);
var validator = z.object({
    _type: z.literal('department'),
    title: z.string().optional(),
    primaryMembers: z.array(departmentMember.validator.merge(arrayEntry.validator)).optional(),
    otherMembers: z.array(departmentMember.validator.merge(arrayEntry.validator)).optional()
});
schema.department;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=department.js.map